const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
      {
        "name": "DictionaryAPI",
        "endpoint": "https://i0t752ujtb.execute-api.us-east-2.amazonaws.com/dev",
        "region": "us-east-2"
      }
    ]
  };
  
  export default awsmobile; 